<div class="list" cdkMenu>
  @for (outage of outages(); track outage.id) {
    <button
      type="button"
      class="list__button"
      cdkMenuItem
      (cdkMenuItemTriggered)="setSelectedOutage(outage.id); zoomToOutage(outage)">
      <app-dot [outageType]="outage.type" />
      <span class="list__label e-text-interactive-md">
        {{ outage.city }},
        <span class="e-sr-only">{{ outage.type | outageType }}, </span>
        {{ outage.affectedCustomers | affectedCount }}
      </span>

      <div class="list__icon">
        <e-icon name="arrowRightCircleColor" size="sm" />
        <e-icon name="arrowRightCircleFilledColor" size="sm" />
      </div>
    </button>
  }
</div>
